/**
 * Created by psherif on 06/04/16.
 */
'use strict';

angular.module('mobile-apps')
  .directive('languageEntry',function($timeout, $window) {
    return {

      link: function (scope, elem, attrs, controller) {

      },
      template : function(tElement, tAttrs) {

      }

    }

  });
